export default {
    overview: () => JIX.Gettext.__('Overblik'),
    language: () => JIX.Gettext.__('Sprog'),
    skills: () => JIX.Gettext.__('Kompetencer'),
    aboutMe: () => JIX.Gettext.__('Om mig'),
    jobExperience: () => JIX.Gettext.__('Joberfaring'),
    education: () => JIX.Gettext.__('Uddannelse'),
    courses: () => JIX.Gettext.__('Kurser og certificeringer'),

    yearsJobExperience: (n) => JIX.Gettext.__nx('{n} års joberfaring', '{n} års joberfaring', n, { n }),
    yearsMgrExperience: (n) => JIX.Gettext.__nx('{n} års ledererfaring', '{n} års ledererfaring', n, { n }),
};
